import React from 'react';
import {useTranslation} from "react-i18next";
import {Text} from "../../../index";

const ManageYourDataStep = () => {
    const {t} = useTranslation();

    return (
        <div className="meeting-step" style={{display: 'flex', flexDirection: "column", gap: 8}}>
            <Text size="f16" font="book" color="black">
                <i style={{color: "#1ABB78"}}>{t('menu_item_artifacts')}</i>{t('manage_your_data_step_1')}
            </Text>
            <Text size="f16" font="book" color="black">
                <i style={{color: "#1ABB78"}}>{t('menu_item_channels')}</i>{t('manage_your_data_step_2')}
            </Text>
        </div>
    );
};

export default ManageYourDataStep;